/**
 * Implement pause button listeners for <video> tags.
 */
document
    .querySelectorAll('.js-pause-button, .js-pause-button-overlay')
    .forEach((el) => {
        el.addEventListener('click', (e) => {
            // console.log('Pause button clicked (for a <video>)');

            let video = el
                ?.closest('.js-pause-button-video-wrapper')
                ?.querySelector('.js-pause-button-video');

            if (!video) {
                return;
            }

            H_Tools.pause.state(e.target, video.paused); // do this before we play or pause the video

            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });
    });
